module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteUser":"Delete User","deleteUserText":"Are you sure you want to delete this user ?"},"al":{"deleteUser":"Fshi Përdorues","deleteUserText":"A jeni i sigurt se dëshironi të fshini këtë përdorues ?"}}')
  delete Component.options._Ctor
}
